/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why are the factors 50, 33 and 40?`)
};

const es_od_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué los factores son 50, 33 y 40?`)
};

const de_od_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum sind die Faktoren 50, 33 und 40?`)
};

const nl_od_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom zijn de factoren 50, 33 en 40?`)
};

const fr_od_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi les facteurs sont-ils 50, 33 et 40 ?`)
};

const it_od_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché i fattori sono 50, 33 e 40?`)
};

const pt_br2_od_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que os fatores são 50, 33 e 40?`)
};

const pt_od_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque são os fatores 50, 33 e 40?`)
};

const ja_od_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`係数が50、33、40である理由は何ですか？`)
};

const zh_od_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么系数是 50、33 和 40？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_faq_q2", locale)
	if (locale === "en") return en_od_faq_q2(inputs)
	if (locale === "es") return es_od_faq_q2(inputs)
	if (locale === "de") return de_od_faq_q2(inputs)
	if (locale === "nl") return nl_od_faq_q2(inputs)
	if (locale === "fr") return fr_od_faq_q2(inputs)
	if (locale === "it") return it_od_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_od_faq_q2(inputs)
	if (locale === "pt") return pt_od_faq_q2(inputs)
	if (locale === "ja") return ja_od_faq_q2(inputs)
	return zh_od_faq_q2(inputs)
};